var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import logger from "./Logger.js";
import { ScenarioStatus } from "./ScenarioLoggingProvider.types.js";
import { createContext, useState, useCallback } from "react";
const logResolvedScenario = (work, status, scenarioProperties) => {
  logger.trackMetric({
    name: `TrackScenario:${work.name}`,
    average: performance.now() - work.start,
    properties: !!scenarioProperties.customFields ? __spreadProps(__spreadValues({}, scenarioProperties.customFields), { scenarioStatus: status }) : { scenarioStatus: status }
  });
};
const createScenarioLoggingContext = (scenarioProperties) => {
  let pendingWork = [];
  const registerPendingWork = (pendingWorkName, scenarioType) => {
    const work = {
      name: pendingWorkName,
      scenarioType,
      start: performance.now(),
      completed: false,
      cancel: (customFields) => {
        work.completed = true;
        const logScenarioProperties = !!customFields ? __spreadProps(__spreadValues({}, scenarioProperties), { customFields }) : scenarioProperties;
        logResolvedScenario(work, ScenarioStatus.Canceled, logScenarioProperties);
      },
      complete: (customFields) => {
        if (!work.completed) {
          work.completed = true;
          const logScenarioProperties = !!customFields ? __spreadProps(__spreadValues({}, scenarioProperties), { customFields }) : scenarioProperties;
          logResolvedScenario(work, ScenarioStatus.Completed, logScenarioProperties);
        }
      },
      reset: () => {
        work.completed = false;
        work.start = performance.now();
      }
    };
    const existingPendingWork = pendingWork.filter((p) => !p.completed && p.name === pendingWorkName);
    if (existingPendingWork.length > 0) {
      existingPendingWork.forEach((unitWork) => unitWork.cancel({}));
    }
    pendingWork.push(work);
    return work;
  };
  const completePendingWork = (pendingWorkName, customFields) => {
    const pendingWorkToComplete = pendingWork.find((p) => !p.completed && p.name === pendingWorkName);
    if (!!pendingWorkToComplete) {
      pendingWorkToComplete.complete(customFields);
      return true;
    }
    return false;
  };
  const cancelPendingWork = (pendingWorkName, customFields) => {
    const pendingWorkToCancel = pendingWork.find((p) => !p.completed && p.name === pendingWorkName);
    if (!!pendingWorkToCancel) {
      pendingWorkToCancel.cancel(customFields);
      return true;
    }
    return false;
  };
  const context = {
    name: scenarioProperties.name,
    pendingWork,
    // @ts-ignore
    registerPendingWork: (pendingWorkName, scenarioType) => {
      return registerPendingWork(pendingWorkName, scenarioType);
    },
    // @ts-ignore
    completePendingWork: (pendingWorkName, customFields) => {
      return completePendingWork(pendingWorkName, customFields);
    },
    // @ts-ignore
    cancelPendingWork: (pendingWorkName, customFields) => {
      return cancelPendingWork(pendingWorkName, customFields);
    },
    resetScenario: () => {
      pendingWork = [];
    }
  };
  return context;
};
const defaultScenarioLoggingContext = createScenarioLoggingContext({});
const ScenarioLoggingContext = createContext({
  registerPendingWork: () => defaultScenarioLoggingContext.pendingWork[0],
  completePendingWork: () => true,
  cancelPendingWork: () => true,
  resetScenario: () => {
  }
});
const ScenarioLoggingProvider = (props) => {
  const scenarioContext = createScenarioLoggingContext(props);
  const [scenarioContextState, setScenarioContextState] = useState(scenarioContext);
  const registerPendingWork = useCallback((pendingWorkName, scenarioType) => {
    const newWork = scenarioContextState.registerPendingWork(pendingWorkName, scenarioType);
    setScenarioContextState(__spreadProps(__spreadValues({}, scenarioContextState), { pendingWork: scenarioContextState.pendingWork.concat(newWork) }));
    return newWork;
  }, []);
  const completePendingWork = useCallback((pendingWorkName, customFields) => {
    const completed = scenarioContextState.completePendingWork(pendingWorkName, customFields);
    if (completed) {
      setScenarioContextState(__spreadProps(__spreadValues({}, scenarioContextState), {
        pendingWork: scenarioContextState.pendingWork.filter((p) => p.name !== pendingWorkName)
      }));
    }
    return completed;
  }, []);
  const cancelPendingWork = useCallback((pendingWorkName, customFields) => {
    const cancelled = scenarioContextState.cancelPendingWork(pendingWorkName, customFields);
    if (cancelled) {
      setScenarioContextState(__spreadProps(__spreadValues({}, scenarioContextState), {
        pendingWork: scenarioContextState.pendingWork.filter((p) => p.name !== pendingWorkName)
      }));
    }
    return cancelled;
  }, []);
  const resetScenario = useCallback(() => {
    setScenarioContextState(__spreadProps(__spreadValues({}, scenarioContextState), {
      pendingWork: []
    }));
  }, []);
  return /* @__PURE__ */ jsx(
    ScenarioLoggingContext.Provider,
    {
      value: {
        registerPendingWork,
        completePendingWork,
        cancelPendingWork,
        resetScenario
      },
      children: props.children
    }
  );
};
export {
  ScenarioLoggingContext,
  ScenarioLoggingProvider,
  createScenarioLoggingContext,
  defaultScenarioLoggingContext
};
//# sourceMappingURL=ScenarioLoggingProvider.js.map
